import { render } from "./DynamicMenuItem.vue?vue&type=template&id=472e016e&ts=true"
import script from "./DynamicMenuItem.vue?vue&type=script&lang=ts"
export * from "./DynamicMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "472e016e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('472e016e', __exports__)) {
    api.reload('472e016e', __exports__)
  }
  
  module.hot.accept("./DynamicMenuItem.vue?vue&type=template&id=472e016e&ts=true", () => {
    api.rerender('472e016e', render)
  })

}


export default __exports__